/**
 * Quarterly history from 2011, used when a dataset is opened.
 * Census/BLS/Freddie via FRED, pulled 21 Sep 2026.
 * Quarterly value = average of the months in the quarter.
 * Mortgage = average of the three month-end weekly prints.
 * Price indexes are rebased so Q1 2019 = 100, matching the overview charts.
 * A star (Q3 26*) means the quarter is not finished.
 * The overview desk keeps the shorter window; these arrays are the long view.
 */

export const LONG_HOUSING_STARTS: { period: string; total: number; single: number }[] = [
  { period: 'Q1 11', total: 0.582, single: 0.417 },
  { period: 'Q2 11', total: 0.574, single: 0.421 },
  { period: 'Q3 11', total: 0.619, single: 0.424 },
  { period: 'Q4 11', total: 0.672, single: 0.475 },
  { period: 'Q1 12', total: 0.707, single: 0.485 },
  { period: 'Q2 12', total: 0.739, single: 0.515 },
  { period: 'Q3 12', total: 0.78, single: 0.549 },
  { period: 'Q4 12', total: 0.908, single: 0.598 },
  { period: 'Q1 13', total: 0.953, single: 0.626 },
  { period: 'Q2 13', total: 0.868, single: 0.603 },
  { period: 'Q3 13', total: 0.882, single: 0.6 },
  { period: 'Q4 13', total: 1.009, single: 0.647 },
  { period: 'Q1 14', total: 0.934, single: 0.604 },
  { period: 'Q2 14', total: 0.987, single: 0.634 },
  { period: 'Q3 14', total: 1.031, single: 0.655 },
  { period: 'Q4 14', total: 1.049, single: 0.692 },
  { period: 'Q1 15', total: 0.977, single: 0.638 },
  { period: 'Q2 15', total: 1.158, single: 0.717 },
  { period: 'Q3 15', total: 1.167, single: 0.746 },
  { period: 'Q4 15', total: 1.125, single: 0.748 },
  { period: 'Q1 16', total: 1.143, single: 0.788 },
  { period: 'Q2 16', total: 1.171, single: 0.766 },
  { period: 'Q3 16', total: 1.159, single: 0.76 },
  { period: 'Q4 16', total: 1.235, single: 0.826 },
  { period: 'Q1 17', total: 1.217, single: 0.828 },
  { period: 'Q2 17', total: 1.184, single: 0.841 },
  { period: 'Q3 17', total: 1.182, single: 0.849 },
  { period: 'Q4 17', total: 1.236, single: 0.875 },
  { period: 'Q1 18', total: 1.298, single: 0.88 },
  { period: 'Q2 18', total: 1.275, single: 0.915 },
  { period: 'Q3 18', total: 1.249, single: 0.881 },
  { period: 'Q4 18', total: 1.166, single: 0.809 },
  { period: 'Q1 19', total: 1.179, single: 0.844 },
  { period: 'Q2 19', total: 1.269, single: 0.866 },
  { period: 'Q3 19', total: 1.309, single: 0.908 },
  { period: 'Q4 19', total: 1.409, single: 0.937 },
  { period: 'Q1 20', total: 1.465, single: 0.961 },
  { period: 'Q2 20', total: 1.08, single: 0.777 },
  { period: 'Q3 20', total: 1.465, single: 1.054 },
  { period: 'Q4 20', total: 1.567, single: 1.21 },
  { period: 'Q1 21', total: 1.57, single: 1.128 },
  { period: 'Q2 21', total: 1.584, single: 1.109 },
  { period: 'Q3 21', total: 1.591, single: 1.117 },
  { period: 'Q4 21', total: 1.668, single: 1.164 },
  { period: 'Q1 22', total: 1.708, single: 1.177 },
  { period: 'Q2 22', total: 1.636, single: 1.089 },
  { period: 'Q3 22', total: 1.465, single: 0.91 },
  { period: 'Q4 22', total: 1.392, single: 0.839 },
  { period: 'Q1 23', total: 1.373, single: 0.826 },
  { period: 'Q2 23', total: 1.457, single: 0.937 },
  { period: 'Q3 23', total: 1.385, single: 0.981 },
  { period: 'Q4 23', total: 1.469, single: 1.045 },
  { period: 'Q1 24', total: 1.41, single: 1.062 },
  { period: 'Q2 24', total: 1.342, single: 1.008 },
  { period: 'Q3 24', total: 1.34, single: 0.982 },
  { period: 'Q4 24', total: 1.388, single: 1.008 },
  { period: 'Q1 25', total: 1.397, single: 1.012 },
  { period: 'Q2 25', total: 1.356, single: 0.941 },
  { period: 'Q3 25', total: 1.347, single: 0.89 },
  { period: 'Q4 25', total: 1.323, single: 0.923 },
  { period: 'Q1 26', total: 1.418, single: 0.945 },
  { period: 'Q2 26', total: 1.345, single: 0.902 },
  { period: 'Q3 26*', total: 1.292, single: 0.885 },
];

export const LONG_MORTGAGE: { period: string; rate: number }[] = [
  { period: 'Q1 11', rate: 4.87 },
  { period: 'Q2 11', rate: 4.63 },
  { period: 'Q3 11', rate: 4.26 },
  { period: 'Q4 11', rate: 4.01 },
  { period: 'Q1 12', rate: 3.97 },
  { period: 'Q2 12', rate: 3.76 },
  { period: 'Q3 12', rate: 3.49 },
  { period: 'Q4 12', rate: 3.36 },
  { period: 'Q1 13', rate: 3.54 },
  { period: 'Q2 13', rate: 3.89 },
  { period: 'Q3 13', rate: 4.38 },
  { period: 'Q4 13', rate: 4.29 },
  { period: 'Q1 14', rate: 4.36 },
  { period: 'Q2 14', rate: 4.2 },
  { period: 'Q3 14', rate: 4.14 },
  { period: 'Q4 14', rate: 3.94 },
  { period: 'Q1 15', rate: 3.72 },
  { period: 'Q2 15', rate: 3.86 },
  { period: 'Q3 15', rate: 3.89 },
  { period: 'Q4 15', rate: 3.91 },
  { period: 'Q1 16', rate: 3.71 },
  { period: 'Q2 16', rate: 3.59 },
  { period: 'Q3 16', rate: 3.44 },
  { period: 'Q4 16', rate: 3.94 },
  { period: 'Q1 17', rate: 4.16 },
  { period: 'Q2 17', rate: 3.95 },
  { period: 'Q3 17', rate: 3.86 },
  { period: 'Q4 17', rate: 3.94 },
  { period: 'Q1 18', rate: 4.33 },
  { period: 'Q2 18', rate: 4.56 },
  { period: 'Q3 18', rate: 4.59 },
  { period: 'Q4 18', rate: 4.74 },
  { period: 'Q1 19', rate: 4.29 },
  { period: 'Q2 19', rate: 3.97 },
  { period: 'Q3 19', rate: 3.66 },
  { period: 'Q4 19', rate: 3.73 },
  { period: 'Q1 20', rate: 3.49 },
  { period: 'Q2 20', rate: 3.17 },
  { period: 'Q3 20', rate: 2.93 },
  { period: 'Q4 20', rate: 2.73 },
  { period: 'Q1 21', rate: 2.96 },
  { period: 'Q2 21', rate: 2.98 },
  { period: 'Q3 21', rate: 2.89 },
  { period: 'Q4 21', rate: 3.12 },
  { period: 'Q1 22', rate: 4.04 },
  { period: 'Q2 22', rate: 5.3 },
  { period: 'Q3 22', rate: 5.85 },
  { period: 'Q4 22', rate: 6.69 },
  { period: 'Q1 23', rate: 6.32 },
  { period: 'Q2 23', rate: 6.57 },
  { period: 'Q3 23', rate: 7.1 },
  { period: 'Q4 23', rate: 7.21 },
  { period: 'Q1 24', rate: 6.81 },
  { period: 'Q2 24', rate: 7.02 },
  { period: 'Q3 24', rate: 6.4 },
  { period: 'Q4 24', rate: 6.79 },
  { period: 'Q1 25', rate: 6.79 },
  { period: 'Q2 25', rate: 6.82 },
  { period: 'Q3 25', rate: 6.53 },
  { period: 'Q4 25', rate: 6.18 },
  { period: 'Q1 26', rate: 6.15 },
  { period: 'Q2 26', rate: 6.44 },
  { period: 'Q3 26*', rate: 6.76 },
];

export const LONG_CONSTRUCTION_FUNNEL: { period: string; permit: number; starts: number; complete: number }[] = [
  { period: 'Q1 11', permit: 0.567, starts: 0.582, complete: 0.575 },
  { period: 'Q2 11', permit: 0.612, starts: 0.574, complete: 0.559 },
  { period: 'Q3 11', permit: 0.626, starts: 0.619, complete: 0.617 },
  { period: 'Q4 11', permit: 0.691, starts: 0.672, complete: 0.587 },
  { period: 'Q1 12', permit: 0.752, starts: 0.707, complete: 0.563 },
  { period: 'Q2 12', permit: 0.774, starts: 0.739, complete: 0.641 },
  { period: 'Q3 12', permit: 0.873, starts: 0.78, complete: 0.671 },
  { period: 'Q4 12', permit: 0.915, starts: 0.908, complete: 0.692 },
  { period: 'Q1 13', permit: 0.952, starts: 0.953, complete: 0.753 },
  { period: 'Q2 13', permit: 0.986, starts: 0.868, complete: 0.719 },
  { period: 'Q3 13', permit: 0.988, starts: 0.882, complete: 0.775 },
  { period: 'Q4 13', permit: 1.026, starts: 1.009, complete: 0.806 },
  { period: 'Q1 14', permit: 1.027, starts: 0.934, complete: 0.869 },
  { period: 'Q2 14', permit: 1.039, starts: 0.987, complete: 0.842 },
  { period: 'Q3 14', permit: 1.067, starts: 1.031, complete: 0.907 },
  { period: 'Q4 14', permit: 1.075, starts: 1.049, complete: 0.913 },
  { period: 'Q1 15', permit: 1.083, starts: 0.977, complete: 0.866 },
  { period: 'Q2 15', permit: 1.272, starts: 1.158, complete: 0.992 },
  { period: 'Q3 15', permit: 1.15, starts: 1.167, complete: 1.001 },
  { period: 'Q4 15', permit: 1.205, starts: 1.125, complete: 1.003 },
  { period: 'Q1 16', permit: 1.154, starts: 1.143, complete: 1.032 },
  { period: 'Q2 16', permit: 1.191, starts: 1.171, complete: 1.018 },
  { period: 'Q3 16', permit: 1.234, starts: 1.159, complete: 1.054 },
  { period: 'Q4 16', permit: 1.244, starts: 1.235, complete: 1.138 },
  { period: 'Q1 17', permit: 1.27, starts: 1.217, complete: 1.125 },
  { period: 'Q2 17', permit: 1.271, starts: 1.184, complete: 1.158 },
  { period: 'Q3 17', permit: 1.283, starts: 1.182, complete: 1.131 },
  { period: 'Q4 17', permit: 1.322, starts: 1.236, complete: 1.193 },
  { period: 'Q1 18', permit: 1.341, starts: 1.298, complete: 1.226 },
  { period: 'Q2 18', permit: 1.354, starts: 1.275, complete: 1.233 },
  { period: 'Q3 18', permit: 1.307, starts: 1.249, complete: 1.2 },
  { period: 'Q4 18', permit: 1.31, starts: 1.166, complete: 1.102 },
  { period: 'Q1 19', permit: 1.278, starts: 1.179, complete: 1.288 },
  { period: 'Q2 19', permit: 1.323, starts: 1.269, complete: 1.236 },
  { period: 'Q3 19', permit: 1.443, starts: 1.309, complete: 1.227 },
  { period: 'Q4 19', permit: 1.5, starts: 1.409, complete: 1.288 },
  { period: 'Q1 20', permit: 1.434, starts: 1.465, complete: 1.261 },
  { period: 'Q2 20', permit: 1.221, starts: 1.08, complete: 1.195 },
  { period: 'Q3 20', permit: 1.574, starts: 1.465, complete: 1.336 },
  { period: 'Q4 20', permit: 1.686, starts: 1.567, complete: 1.343 },
  { period: 'Q1 21', permit: 1.772, starts: 1.57, complete: 1.368 },
  { period: 'Q2 21', permit: 1.692, starts: 1.584, complete: 1.337 },
  { period: 'Q3 21', permit: 1.685, starts: 1.591, complete: 1.31 },
  { period: 'Q4 21', permit: 1.785, starts: 1.668, complete: 1.346 },
  { period: 'Q1 22', permit: 1.889, starts: 1.708, complete: 1.318 },
  { period: 'Q2 22', permit: 1.762, starts: 1.636, complete: 1.377 },
  { period: 'Q3 22', permit: 1.619, starts: 1.465, complete: 1.41 },
  { period: 'Q4 22', permit: 1.468, starts: 1.392, complete: 1.445 },
  { period: 'Q1 23', permit: 1.498, starts: 1.373, complete: 1.478 },
  { period: 'Q2 23', permit: 1.503, starts: 1.457, complete: 1.458 },
  { period: 'Q3 23', permit: 1.552, starts: 1.385, complete: 1.396 },
  { period: 'Q4 23', permit: 1.513, starts: 1.469, complete: 1.469 },
  { period: 'Q1 24', permit: 1.532, starts: 1.41, complete: 1.564 },
  { period: 'Q2 24', permit: 1.44, starts: 1.342, complete: 1.641 },
  { period: 'Q3 24', permit: 1.454, starts: 1.34, complete: 1.694 },
  { period: 'Q4 24', permit: 1.471, starts: 1.388, complete: 1.594 },
  { period: 'Q1 25', permit: 1.467, starts: 1.397, complete: 1.599 },
  { period: 'Q2 25', permit: 1.42, starts: 1.356, complete: 1.46 },
  { period: 'Q3 25', permit: 1.397, starts: 1.347, complete: 1.463 },
  { period: 'Q4 25', permit: 1.438, starts: 1.323, complete: 1.442 },
  { period: 'Q1 26', permit: 1.432, starts: 1.418, complete: 1.379 },
  { period: 'Q2 26', permit: 1.402, starts: 1.345, complete: 1.376 },
  { period: 'Q3 26*', permit: 1.413, starts: 1.292, complete: 1.204 },
];

export const LONG_REGIONAL_STARTS: { period: string; south: number; midwest: number; west: number; ne: number }[] = [
  { period: 'Q1 11', south: 0.318, midwest: 0.087, west: 0.108, ne: 0.069 },
  { period: 'Q2 11', south: 0.277, midwest: 0.108, west: 0.129, ne: 0.061 },
  { period: 'Q3 11', south: 0.312, midwest: 0.093, west: 0.147, ne: 0.068 },
  { period: 'Q4 11', south: 0.329, midwest: 0.125, west: 0.143, ne: 0.075 },
  { period: 'Q1 12', south: 0.388, midwest: 0.106, west: 0.138, ne: 0.075 },
  { period: 'Q2 12', south: 0.377, midwest: 0.11, west: 0.173, ne: 0.078 },
  { period: 'Q3 12', south: 0.384, midwest: 0.13, west: 0.186, ne: 0.08 },
  { period: 'Q4 12', south: 0.449, midwest: 0.168, west: 0.203, ne: 0.087 },
  { period: 'Q1 13', south: 0.513, midwest: 0.123, west: 0.221, ne: 0.096 },
  { period: 'Q2 13', south: 0.438, midwest: 0.137, west: 0.204, ne: 0.089 },
  { period: 'Q3 13', south: 0.422, midwest: 0.159, west: 0.201, ne: 0.1 },
  { period: 'Q4 13', south: 0.496, midwest: 0.175, west: 0.239, ne: 0.099 },
  { period: 'Q1 14', south: 0.489, midwest: 0.113, west: 0.221, ne: 0.112 },
  { period: 'Q2 14', south: 0.477, midwest: 0.184, west: 0.222, ne: 0.103 },
  { period: 'Q3 14', south: 0.504, midwest: 0.172, west: 0.237, ne: 0.117 },
  { period: 'Q4 14', south: 0.516, midwest: 0.166, west: 0.262, ne: 0.105 },
  { period: 'Q1 15', south: 0.517, midwest: 0.127, west: 0.248, ne: 0.085 },
  { period: 'Q2 15', south: 0.528, midwest: 0.153, west: 0.291, ne: 0.186 },
  { period: 'Q3 15', south: 0.609, midwest: 0.154, west: 0.271, ne: 0.133 },
  { period: 'Q4 15', south: 0.57, midwest: 0.167, west: 0.25, ne: 0.138 },
  { period: 'Q1 16', south: 0.573, midwest: 0.172, west: 0.272, ne: 0.126 },
  { period: 'Q2 16', south: 0.596, midwest: 0.196, west: 0.273, ne: 0.106 },
  { period: 'Q3 16', south: 0.586, midwest: 0.16, west: 0.293, ne: 0.12 },
  { period: 'Q4 16', south: 0.585, midwest: 0.209, west: 0.33, ne: 0.111 },
  { period: 'Q1 17', south: 0.644, midwest: 0.172, west: 0.285, ne: 0.116 },
  { period: 'Q2 17', south: 0.559, midwest: 0.192, west: 0.322, ne: 0.111 },
  { period: 'Q3 17', south: 0.584, midwest: 0.174, west: 0.315, ne: 0.109 },
  { period: 'Q4 17', south: 0.613, midwest: 0.182, west: 0.331, ne: 0.109 },
  { period: 'Q1 18', south: 0.637, midwest: 0.156, west: 0.384, ne: 0.121 },
  { period: 'Q2 18', south: 0.634, midwest: 0.189, west: 0.348, ne: 0.104 },
  { period: 'Q3 18', south: 0.624, midwest: 0.18, west: 0.33, ne: 0.115 },
  { period: 'Q4 18', south: 0.626, midwest: 0.154, west: 0.282, ne: 0.104 },
  { period: 'Q1 19', south: 0.657, midwest: 0.139, west: 0.283, ne: 0.101 },
  { period: 'Q2 19', south: 0.671, midwest: 0.169, west: 0.32, ne: 0.109 },
  { period: 'Q3 19', south: 0.688, midwest: 0.176, west: 0.316, ne: 0.128 },
  { period: 'Q4 19', south: 0.73, midwest: 0.193, west: 0.365, ne: 0.122 },
  { period: 'Q1 20', south: 0.787, midwest: 0.171, west: 0.371, ne: 0.135 },
  { period: 'Q2 20', south: 0.579, midwest: 0.162, west: 0.261, ne: 0.078 },
  { period: 'Q3 20', south: 0.783, midwest: 0.225, west: 0.341, ne: 0.116 },
  { period: 'Q4 20', south: 0.82, midwest: 0.211, west: 0.414, ne: 0.122 },
  { period: 'Q1 21', south: 0.81, midwest: 0.205, west: 0.399, ne: 0.155 },
  { period: 'Q2 21', south: 0.82, midwest: 0.214, west: 0.401, ne: 0.149 },
  { period: 'Q3 21', south: 0.88, midwest: 0.198, west: 0.391, ne: 0.122 },
  { period: 'Q4 21', south: 0.881, midwest: 0.25, west: 0.414, ne: 0.123 },
  { period: 'Q1 22', south: 0.913, midwest: 0.221, west: 0.427, ne: 0.146 },
  { period: 'Q2 22', south: 0.919, midwest: 0.217, west: 0.371, ne: 0.13 },
  { period: 'Q3 22', south: 0.755, midwest: 0.187, west: 0.356, ne: 0.167 },
  { period: 'Q4 22', south: 0.739, midwest: 0.2, west: 0.327, ne: 0.126 },
  { period: 'Q1 23', south: 0.795, midwest: 0.148, west: 0.294, ne: 0.136 },
  { period: 'Q2 23', south: 0.819, midwest: 0.201, west: 0.331, ne: 0.107 },
  { period: 'Q3 23', south: 0.775, midwest: 0.178, west: 0.323, ne: 0.108 },
  { period: 'Q4 23', south: 0.782, midwest: 0.205, west: 0.37, ne: 0.112 },
  { period: 'Q1 24', south: 0.793, midwest: 0.175, west: 0.325, ne: 0.116 },
  { period: 'Q2 24', south: 0.768, midwest: 0.166, west: 0.301, ne: 0.107 },
  { period: 'Q3 24', south: 0.713, midwest: 0.19, west: 0.284, ne: 0.153 },
  { period: 'Q4 24', south: 0.749, midwest: 0.21, west: 0.302, ne: 0.127 },
  { period: 'Q1 25', south: 0.738, midwest: 0.176, west: 0.358, ne: 0.125 },
  { period: 'Q2 25', south: 0.718, midwest: 0.202, west: 0.282, ne: 0.154 },
  { period: 'Q3 25', south: 0.72, midwest: 0.218, west: 0.289, ne: 0.121 },
  { period: 'Q4 25', south: 0.712, midwest: 0.187, west: 0.279, ne: 0.145 },
  { period: 'Q1 26', south: 0.765, midwest: 0.183, west: 0.309, ne: 0.161 },
  { period: 'Q2 26', south: 0.706, midwest: 0.218, west: 0.292, ne: 0.129 },
  { period: 'Q3 26*', south: 0.662, midwest: 0.211, west: 0.283, ne: 0.135 },
];

export const LONG_STRUCTURE_STARTS: { period: string; sf: number; mf: number }[] = [
  { period: 'Q1 11', sf: 0.417, mf: 0.152 },
  { period: 'Q2 11', sf: 0.421, mf: 0.144 },
  { period: 'Q3 11', sf: 0.424, mf: 0.188 },
  { period: 'Q4 11', sf: 0.475, mf: 0.181 },
  { period: 'Q1 12', sf: 0.485, mf: 0.211 },
  { period: 'Q2 12', sf: 0.515, mf: 0.213 },
  { period: 'Q3 12', sf: 0.549, mf: 0.222 },
  { period: 'Q4 12', sf: 0.598, mf: 0.294 },
  { period: 'Q1 13', sf: 0.626, mf: 0.311 },
  { period: 'Q2 13', sf: 0.603, mf: 0.253 },
  { period: 'Q3 13', sf: 0.6, mf: 0.268 },
  { period: 'Q4 13', sf: 0.647, mf: 0.348 },
  { period: 'Q1 14', sf: 0.604, mf: 0.319 },
  { period: 'Q2 14', sf: 0.634, mf: 0.34 },
  { period: 'Q3 14', sf: 0.655, mf: 0.361 },
  { period: 'Q4 14', sf: 0.692, mf: 0.342 },
  { period: 'Q1 15', sf: 0.638, mf: 0.328 },
  { period: 'Q2 15', sf: 0.717, mf: 0.427 },
  { period: 'Q3 15', sf: 0.746, mf: 0.411 },
  { period: 'Q4 15', sf: 0.748, mf: 0.366 },
  { period: 'Q1 16', sf: 0.788, mf: 0.342 },
  { period: 'Q2 16', sf: 0.766, mf: 0.393 },
  { period: 'Q3 16', sf: 0.76, mf: 0.386 },
  { period: 'Q4 16', sf: 0.826, mf: 0.401 },
  { period: 'Q1 17', sf: 0.828, mf: 0.379 },
  { period: 'Q2 17', sf: 0.841, mf: 0.331 },
  { period: 'Q3 17', sf: 0.849, mf: 0.32 },
  { period: 'Q4 17', sf: 0.875, mf: 0.35 },
  { period: 'Q1 18', sf: 0.88, mf: 0.403 },
  { period: 'Q2 18', sf: 0.915, mf: 0.346 },
  { period: 'Q3 18', sf: 0.881, mf: 0.357 },
  { period: 'Q4 18', sf: 0.809, mf: 0.34 },
  { period: 'Q1 19', sf: 0.844, mf: 0.327 },
  { period: 'Q2 19', sf: 0.866, mf: 0.389 },
  { period: 'Q3 19', sf: 0.908, mf: 0.388 },
  { period: 'Q4 19', sf: 0.937, mf: 0.455 },
  { period: 'Q1 20', sf: 0.961, mf: 0.491 },
  { period: 'Q2 20', sf: 0.777, mf: 0.293 },
  { period: 'Q3 20', sf: 1.054, mf: 0.398 },
  { period: 'Q4 20', sf: 1.21, mf: 0.343 },
  { period: 'Q1 21', sf: 1.128, mf: 0.426 },
  { period: 'Q2 21', sf: 1.109, mf: 0.464 },
  { period: 'Q3 21', sf: 1.117, mf: 0.465 },
  { period: 'Q4 21', sf: 1.164, mf: 0.494 },
  { period: 'Q1 22', sf: 1.177, mf: 0.512 },
  { period: 'Q2 22', sf: 1.089, mf: 0.531 },
  { period: 'Q3 22', sf: 0.91, mf: 0.537 },
  { period: 'Q4 22', sf: 0.839, mf: 0.541 },
  { period: 'Q1 23', sf: 0.826, mf: 0.532 },
  { period: 'Q2 23', sf: 0.937, mf: 0.508 },
  { period: 'Q3 23', sf: 0.981, mf: 0.393 },
  { period: 'Q4 23', sf: 1.045, mf: 0.407 },
  { period: 'Q1 24', sf: 1.062, mf: 0.334 },
  { period: 'Q2 24', sf: 1.008, mf: 0.32 },
  { period: 'Q3 24', sf: 0.982, mf: 0.334 },
  { period: 'Q4 24', sf: 1.008, mf: 0.36 },
  { period: 'Q1 25', sf: 1.012, mf: 0.363 },
  { period: 'Q2 25', sf: 0.941, mf: 0.394 },
  { period: 'Q3 25', sf: 0.89, mf: 0.444 },
  { period: 'Q4 25', sf: 0.923, mf: 0.38 },
  { period: 'Q1 26', sf: 0.945, mf: 0.455 },
  { period: 'Q2 26', sf: 0.902, mf: 0.432 },
  { period: 'Q3 26*', sf: 0.885, mf: 0.394 },
];

export const LONG_SF_FUNNEL: { period: string; permit: number; starts: number; complete: number }[] = [
  { period: 'Q1 11', permit: 0.399, starts: 0.417, complete: 0.424 },
  { period: 'Q2 11', permit: 0.409, starts: 0.421, complete: 0.443 },
  { period: 'Q3 11', permit: 0.423, starts: 0.424, complete: 0.464 },
  { period: 'Q4 11', permit: 0.449, starts: 0.475, complete: 0.454 },
  { period: 'Q1 12', permit: 0.479, starts: 0.485, complete: 0.416 },
  { period: 'Q2 12', permit: 0.493, starts: 0.515, complete: 0.484 },
  { period: 'Q3 12', permit: 0.534, starts: 0.549, complete: 0.493 },
  { period: 'Q4 12', permit: 0.573, starts: 0.598, complete: 0.521 },
  { period: 'Q1 13', permit: 0.604, starts: 0.626, complete: 0.579 },
  { period: 'Q2 13', permit: 0.624, starts: 0.603, complete: 0.535 },
  { period: 'Q3 13', permit: 0.626, starts: 0.6, complete: 0.575 },
  { period: 'Q4 13', permit: 0.622, starts: 0.647, complete: 0.588 },
  { period: 'Q1 14', permit: 0.616, starts: 0.604, complete: 0.618 },
  { period: 'Q2 14', permit: 0.632, starts: 0.634, complete: 0.6 },
  { period: 'Q3 14', permit: 0.653, starts: 0.655, complete: 0.626 },
  { period: 'Q4 14', permit: 0.658, starts: 0.692, complete: 0.633 },
  { period: 'Q1 15', permit: 0.649, starts: 0.638, complete: 0.612 },
  { period: 'Q2 15', permit: 0.695, starts: 0.717, complete: 0.654 },
  { period: 'Q3 15', permit: 0.71, starts: 0.746, complete: 0.653 },
  { period: 'Q4 15', permit: 0.723, starts: 0.748, complete: 0.668 },
  { period: 'Q1 16', permit: 0.727, starts: 0.788, complete: 0.704 },
  { period: 'Q2 16', permit: 0.751, starts: 0.766, complete: 0.727 },
  { period: 'Q3 16', permit: 0.741, starts: 0.76, complete: 0.742 },
  { period: 'Q4 16', permit: 0.783, starts: 0.826, complete: 0.776 },
  { period: 'Q1 17', permit: 0.809, starts: 0.828, complete: 0.771 },
  { period: 'Q2 17', permit: 0.803, starts: 0.841, complete: 0.792 },
  { period: 'Q3 17', permit: 0.821, starts: 0.849, complete: 0.794 },
  { period: 'Q4 17', permit: 0.858, starts: 0.875, complete: 0.823 },
  { period: 'Q1 18', permit: 0.856, starts: 0.88, complete: 0.848 },
  { period: 'Q2 18', permit: 0.863, starts: 0.915, complete: 0.84 },
  { period: 'Q3 18', permit: 0.861, starts: 0.881, complete: 0.873 },
  { period: 'Q4 18', permit: 0.835, starts: 0.809, complete: 0.805 },
  { period: 'Q1 19', permit: 0.801, starts: 0.844, complete: 0.875 },
  { period: 'Q2 19', permit: 0.826, starts: 0.866, complete: 0.893 },
  { period: 'Q3 19', permit: 0.892, starts: 0.908, complete: 0.91 },
  { period: 'Q4 19', permit: 0.937, starts: 0.937, complete: 0.937 },
  { period: 'Q1 20', permit: 0.941, starts: 0.961, complete: 0.905 },
  { period: 'Q2 20', permit: 0.76, starts: 0.777, complete: 0.873 },
  { period: 'Q3 20', permit: 1.077, starts: 1.054, complete: 0.93 },
  { period: 'Q4 20', permit: 1.178, starts: 1.21, complete: 0.934 },
  { period: 'Q1 21', permit: 1.173, starts: 1.128, complete: 1.006 },
  { period: 'Q2 21', permit: 1.114, starts: 1.109, complete: 0.95 },
  { period: 'Q3 21', permit: 1.067, starts: 1.117, complete: 0.948 },
  { period: 'Q4 21', permit: 1.12, starts: 1.164, complete: 0.978 },
  { period: 'Q1 22', permit: 1.185, starts: 1.177, complete: 1.015 },
  { period: 'Q2 22', permit: 1.026, starts: 1.089, complete: 1.014 },
  { period: 'Q3 22', permit: 0.894, starts: 0.91, complete: 1.026 },
  { period: 'Q4 22', permit: 0.789, starts: 0.839, complete: 1.028 },
  { period: 'Q1 23', permit: 0.796, starts: 0.826, complete: 1.034 },
  { period: 'Q2 23', permit: 0.919, starts: 0.937, complete: 0.987 },
  { period: 'Q3 23', permit: 0.976, starts: 0.981, complete: 0.981 },
  { period: 'Q4 23', permit: 0.995, starts: 1.045, complete: 0.997 },
  { period: 'Q1 24', permit: 1.013, starts: 1.062, complete: 0.977 },
  { period: 'Q2 24', permit: 0.966, starts: 1.008, complete: 1.076 },
  { period: 'Q3 24', permit: 0.963, starts: 0.982, complete: 1.038 },
  { period: 'Q4 24', permit: 0.973, starts: 1.008, complete: 0.973 },
  { period: 'Q1 25', permit: 0.975, starts: 1.012, complete: 1.039 },
  { period: 'Q2 25', permit: 0.899, starts: 0.941, complete: 0.978 },
  { period: 'Q3 25', permit: 0.88, starts: 0.89, complete: 1.003 },
  { period: 'Q4 25', permit: 0.895, starts: 0.923, complete: 0.996 },
  { period: 'Q1 26', permit: 0.901, starts: 0.945, complete: 0.918 },
  { period: 'Q2 26', permit: 0.882, starts: 0.902, complete: 0.91 },
  { period: 'Q3 26*', permit: 0.886, starts: 0.885, complete: 0.864 },
];

export const LONG_STARTS_VS_SALES: { period: string; starts: number; sold: number }[] = [
  { period: 'Q1 11', starts: 0.417, sold: 0.292 },
  { period: 'Q2 11', starts: 0.421, sold: 0.305 },
  { period: 'Q3 11', starts: 0.424, sold: 0.3 },
  { period: 'Q4 11', starts: 0.475, sold: 0.328 },
  { period: 'Q1 12', starts: 0.485, sold: 0.352 },
  { period: 'Q2 12', starts: 0.515, sold: 0.361 },
  { period: 'Q3 12', starts: 0.549, sold: 0.376 },
  { period: 'Q4 12', starts: 0.598, sold: 0.383 },
  { period: 'Q1 13', starts: 0.626, sold: 0.446 },
  { period: 'Q2 13', starts: 0.603, sold: 0.446 },
  { period: 'Q3 13', starts: 0.6, sold: 0.386 },
  { period: 'Q4 13', starts: 0.647, sold: 0.441 },
  { period: 'Q1 14', starts: 0.604, sold: 0.423 },
  { period: 'Q2 14', starts: 0.634, sold: 0.424 },
  { period: 'Q3 14', starts: 0.655, sold: 0.443 },
  { period: 'Q4 14', starts: 0.692, sold: 0.472 },
  { period: 'Q1 15', starts: 0.638, sold: 0.512 },
  { period: 'Q2 15', starts: 0.717, sold: 0.495 },
  { period: 'Q3 15', starts: 0.746, sold: 0.493 },
  { period: 'Q4 15', starts: 0.748, sold: 0.511 },
  { period: 'Q1 16', starts: 0.788, sold: 0.518 },
  { period: 'Q2 16', starts: 0.766, sold: 0.568 },
  { period: 'Q3 16', starts: 0.76, sold: 0.587 },
  { period: 'Q4 16', starts: 0.826, sold: 0.569 },
  { period: 'Q1 17', starts: 0.828, sold: 0.597 },
  { period: 'Q2 17', starts: 0.841, sold: 0.617 },
  { period: 'Q3 17', starts: 0.849, sold: 0.588 },
  { period: 'Q4 17', starts: 0.875, sold: 0.656 },
  { period: 'Q1 18', starts: 0.88, sold: 0.629 },
  { period: 'Q2 18', starts: 0.915, sold: 0.647 },
  { period: 'Q3 18', starts: 0.881, sold: 0.605 },
  { period: 'Q4 18', starts: 0.809, sold: 0.575 },
  { period: 'Q1 19', starts: 0.844, sold: 0.654 },
  { period: 'Q2 19', starts: 0.866, sold: 0.683 },
  { period: 'Q3 19', starts: 0.908, sold: 0.691 },
  { period: 'Q4 19', starts: 0.937, sold: 0.712 },
  { period: 'Q1 20', starts: 0.961, sold: 0.674 },
  { period: 'Q2 20', starts: 0.777, sold: 0.728 },
  { period: 'Q3 20', starts: 1.054, sold: 0.992 },
  { period: 'Q4 20', starts: 1.21, sold: 0.927 },
  { period: 'Q1 21', starts: 1.128, sold: 0.841 },
  { period: 'Q2 21', starts: 1.109, sold: 0.749 },
  { period: 'Q3 21', starts: 1.117, sold: 0.722 },
  { period: 'Q4 21', starts: 1.164, sold: 0.762 },
  { period: 'Q1 22', starts: 1.177, sold: 0.768 },
  { period: 'Q2 22', starts: 1.089, sold: 0.605 },
  { period: 'Q3 22', starts: 0.91, sold: 0.574 },
  { period: 'Q4 22', starts: 0.839, sold: 0.598 },
  { period: 'Q1 23', starts: 0.826, sold: 0.642 },
  { period: 'Q2 23', starts: 0.937, sold: 0.693 },
  { period: 'Q3 23', starts: 0.981, sold: 0.685 },
  { period: 'Q4 23', starts: 1.045, sold: 0.643 },
  { period: 'Q1 24', starts: 1.062, sold: 0.672 },
  { period: 'Q2 24', starts: 1.008, sold: 0.686 },
  { period: 'Q3 24', starts: 0.982, sold: 0.711 },
  { period: 'Q4 24', starts: 1.008, sold: 0.668 },
  { period: 'Q1 25', starts: 1.012, sold: 0.654 },
  { period: 'Q2 25', starts: 0.941, sold: 0.663 },
  { period: 'Q3 25', starts: 0.89, sold: 0.687 },
  { period: 'Q4 25', starts: 0.923, sold: 0.711 },
  { period: 'Q1 26', starts: 0.945, sold: 0.622 },
  { period: 'Q2 26', starts: 0.902, sold: 0.65 },
  { period: 'Q3 26*', starts: 0.885, sold: 0.607 },
];

export const LONG_NEW_HOME_MOS: { period: string; mos: number }[] = [
  { period: 'Q1 11', mos: 7.53 },
  { period: 'Q2 11', mos: 6.63 },
  { period: 'Q3 11', mos: 6.5 },
  { period: 'Q4 11', mos: 5.67 },
  { period: 'Q1 12', mos: 5.0 },
  { period: 'Q2 12', mos: 4.8 },
  { period: 'Q3 12', mos: 4.57 },
  { period: 'Q4 12', mos: 4.67 },
  { period: 'Q1 13', mos: 4.1 },
  { period: 'Q2 13', mos: 4.37 },
  { period: 'Q3 13', mos: 5.47 },
  { period: 'Q4 13', mos: 5.03 },
  { period: 'Q1 14', mos: 5.33 },
  { period: 'Q2 14', mos: 5.53 },
  { period: 'Q3 14', mos: 5.67 },
  { period: 'Q4 14', mos: 5.37 },
  { period: 'Q1 15', mos: 4.8 },
  { period: 'Q2 15', mos: 5.1 },
  { period: 'Q3 15', mos: 5.37 },
  { period: 'Q4 15', mos: 5.4 },
  { period: 'Q1 16', mos: 5.53 },
  { period: 'Q2 16', mos: 5.13 },
  { period: 'Q3 16', mos: 4.9 },
  { period: 'Q4 16', mos: 5.27 },
  { period: 'Q1 17', mos: 5.23 },
  { period: 'Q2 17', mos: 5.27 },
  { period: 'Q3 17', mos: 5.73 },
  { period: 'Q4 17', mos: 5.3 },
  { period: 'Q1 18', mos: 5.63 },
  { period: 'Q2 18', mos: 5.63 },
  { period: 'Q3 18', mos: 6.37 },
  { period: 'Q4 18', mos: 7.07 },
  { period: 'Q1 19', mos: 6.3 },
  { period: 'Q2 19', mos: 5.87 },
  { period: 'Q3 19', mos: 5.67 },
  { period: 'Q4 19', mos: 5.4 },
  { period: 'Q1 20', mos: 5.9 },
  { period: 'Q2 20', mos: 5.37 },
  { period: 'Q3 20', mos: 3.47 },
  { period: 'Q4 20', mos: 3.77 },
  { period: 'Q1 21', mos: 4.4 },
  { period: 'Q2 21', mos: 5.37 },
  { period: 'Q3 21', mos: 6.17 },
  { period: 'Q4 21', mos: 6.13 },
  { period: 'Q1 22', mos: 6.27 },
  { period: 'Q2 22', mos: 8.7 },
  { period: 'Q3 22', mos: 9.73 },
  { period: 'Q4 22', mos: 9.23 },
  { period: 'Q1 23', mos: 8.17 },
  { period: 'Q2 23', mos: 7.4 },
  { period: 'Q3 23', mos: 7.57 },
  { period: 'Q4 23', mos: 8.4 },
  { period: 'Q1 24', mos: 8.27 },
  { period: 'Q2 24', mos: 8.13 },
  { period: 'Q3 24', mos: 7.9 },
  { period: 'Q4 24', mos: 8.77 },
  { period: 'Q1 25', mos: 9.23 },
  { period: 'Q2 25', mos: 9.1 },
  { period: 'Q3 25', mos: 8.63 },
  { period: 'Q4 25', mos: 8.2 },
  { period: 'Q1 26', mos: 9.3 },
  { period: 'Q2 26', mos: 8.93 },
  { period: 'Q3 26*', mos: 9.6 },
];

export const LONG_HOUSING_BACKLOG: { period: string; under: number; notStarted: number }[] = [
  { period: 'Q1 11', under: 0.425, notStarted: 0.08 },
  { period: 'Q2 11', under: 0.416, notStarted: 0.083 },
  { period: 'Q3 11', under: 0.416, notStarted: 0.083 },
  { period: 'Q4 11', under: 0.43, notStarted: 0.076 },
  { period: 'Q1 12', under: 0.45, notStarted: 0.08 },
  { period: 'Q2 12', under: 0.474, notStarted: 0.084 },
  { period: 'Q3 12', under: 0.499, notStarted: 0.092 },
  { period: 'Q4 12', under: 0.535, notStarted: 0.091 },
  { period: 'Q1 13', under: 0.579, notStarted: 0.091 },
  { period: 'Q2 13', under: 0.618, notStarted: 0.1 },
  { period: 'Q3 13', under: 0.652, notStarted: 0.105 },
  { period: 'Q4 13', under: 0.688, notStarted: 0.107 },
  { period: 'Q1 14', under: 0.718, notStarted: 0.108 },
  { period: 'Q2 14', under: 0.756, notStarted: 0.113 },
  { period: 'Q3 14', under: 0.793, notStarted: 0.112 },
  { period: 'Q4 14', under: 0.815, notStarted: 0.117 },
  { period: 'Q1 15', under: 0.834, notStarted: 0.124 },
  { period: 'Q2 15', under: 0.881, notStarted: 0.146 },
  { period: 'Q3 15', under: 0.923, notStarted: 0.145 },
  { period: 'Q4 15', under: 0.958, notStarted: 0.14 },
  { period: 'Q1 16', under: 0.979, notStarted: 0.148 },
  { period: 'Q2 16', under: 1.008, notStarted: 0.145 },
  { period: 'Q3 16', under: 1.036, notStarted: 0.135 },
  { period: 'Q4 16', under: 1.051, notStarted: 0.132 },
  { period: 'Q1 17', under: 1.068, notStarted: 0.138 },
  { period: 'Q2 17', under: 1.073, notStarted: 0.15 },
  { period: 'Q3 17', under: 1.084, notStarted: 0.148 },
  { period: 'Q4 17', under: 1.103, notStarted: 0.149 },
  { period: 'Q1 18', under: 1.112, notStarted: 0.16 },
  { period: 'Q2 18', under: 1.127, notStarted: 0.168 },
  { period: 'Q3 18', under: 1.13, notStarted: 0.17 },
  { period: 'Q4 18', under: 1.144, notStarted: 0.174 },
  { period: 'Q1 19', under: 1.138, notStarted: 0.189 },
  { period: 'Q2 19', under: 1.133, notStarted: 0.175 },
  { period: 'Q3 19', under: 1.152, notStarted: 0.168 },
  { period: 'Q4 19', under: 1.167, notStarted: 0.184 },
  { period: 'Q1 20', under: 1.206, notStarted: 0.168 },
  { period: 'Q2 20', under: 1.185, notStarted: 0.17 },
  { period: 'Q3 20', under: 1.214, notStarted: 0.17 },
  { period: 'Q4 20', under: 1.246, notStarted: 0.18 },
  { period: 'Q1 21', under: 1.289, notStarted: 0.218 },
  { period: 'Q2 21', under: 1.344, notStarted: 0.253 },
  { period: 'Q3 21', under: 1.414, notStarted: 0.253 },
  { period: 'Q4 21', under: 1.495, notStarted: 0.259 },
  { period: 'Q1 22', under: 1.585, notStarted: 0.281 },
  { period: 'Q2 22', under: 1.679, notStarted: 0.292 },
  { period: 'Q3 22', under: 1.696, notStarted: 0.298 },
  { period: 'Q4 22', under: 1.703, notStarted: 0.292 },
  { period: 'Q1 23', under: 1.684, notStarted: 0.3 },
  { period: 'Q2 23', under: 1.687, notStarted: 0.287 },
  { period: 'Q3 23', under: 1.692, notStarted: 0.27 },
  { period: 'Q4 23', under: 1.685, notStarted: 0.271 },
  { period: 'Q1 24', under: 1.656, notStarted: 0.273 },
  { period: 'Q2 24', under: 1.59, notStarted: 0.278 },
  { period: 'Q3 24', under: 1.519, notStarted: 0.282 },
  { period: 'Q4 24', under: 1.443, notStarted: 0.277 },
  { period: 'Q1 25', under: 1.405, notStarted: 0.279 },
  { period: 'Q2 25', under: 1.368, notStarted: 0.271 },
  { period: 'Q3 25', under: 1.326, notStarted: 0.248 },
  { period: 'Q4 25', under: 1.298, notStarted: 0.255 },
  { period: 'Q1 26', under: 1.267, notStarted: 0.264 },
  { period: 'Q2 26', under: 1.259, notStarted: 0.271 },
  { period: 'Q3 26*', under: 1.269, notStarted: 0.277 },
];

export const LONG_PUT_IN_PLACE: { period: string; resi: number; nonres: number }[] = [
  { period: 'Q1 11', resi: 240.7, nonres: 230.8 },
  { period: 'Q2 11', resi: 245.9, nonres: 249.9 },
  { period: 'Q3 11', resi: 250.6, nonres: 269.7 },
  { period: 'Q4 11', resi: 249.4, nonres: 277.6 },
  { period: 'Q1 12', resi: 250.6, nonres: 295.0 },
  { period: 'Q2 12', resi: 264.0, nonres: 304.2 },
  { period: 'Q3 12', resi: 279.6, nonres: 304.3 },
  { period: 'Q4 12', resi: 296.6, nonres: 304.1 },
  { period: 'Q1 13', resi: 308.3, nonres: 291.8 },
  { period: 'Q2 13', resi: 321.0, nonres: 297.9 },
  { period: 'Q3 13', resi: 334.7, nonres: 320.4 },
  { period: 'Q4 13', resi: 353.4, nonres: 341.1 },
  { period: 'Q1 14', resi: 367.2, nonres: 356.3 },
  { period: 'Q2 14', resi: 374.9, nonres: 359.0 },
  { period: 'Q3 14', resi: 375.8, nonres: 361.3 },
  { period: 'Q4 14', resi: 393.1, nonres: 372.4 },
  { period: 'Q1 15', resi: 408.3, nonres: 383.5 },
  { period: 'Q2 15', resi: 423.9, nonres: 416.9 },
  { period: 'Q3 15', resi: 442.5, nonres: 416.7 },
  { period: 'Q4 15', resi: 449.4, nonres: 409.3 },
  { period: 'Q1 16', resi: 462.8, nonres: 409.8 },
  { period: 'Q2 16', resi: 470.6, nonres: 431.8 },
  { period: 'Q3 16', resi: 480.3, nonres: 448.3 },
  { period: 'Q4 16', resi: 504.5, nonres: 455.5 },
  { period: 'Q1 17', resi: 523.8, nonres: 451.1 },
  { period: 'Q2 17', resi: 535.2, nonres: 446.3 },
  { period: 'Q3 17', resi: 542.3, nonres: 438.3 },
  { period: 'Q4 17', resi: 555.4, nonres: 443.8 },
  { period: 'Q1 18', resi: 573.8, nonres: 471.5 },
  { period: 'Q2 18', resi: 572.4, nonres: 468.1 },
  { period: 'Q3 18', resi: 552.8, nonres: 464.0 },
  { period: 'Q4 18', resi: 532.9, nonres: 460.2 },
  { period: 'Q1 19', resi: 517.2, nonres: 465.9 },
  { period: 'Q2 19', resi: 530.2, nonres: 489.1 },
  { period: 'Q3 19', resi: 558.6, nonres: 516.4 },
  { period: 'Q4 19', resi: 579.2, nonres: 528.4 },
  { period: 'Q1 20', resi: 606.5, nonres: 518.2 },
  { period: 'Q2 20', resi: 589.4, nonres: 494.1 },
  { period: 'Q3 20', resi: 638.6, nonres: 487.5 },
  { period: 'Q4 20', resi: 705.5, nonres: 483.3 },
  { period: 'Q1 21', resi: 745.9, nonres: 486.1 },
  { period: 'Q2 21', resi: 779.2, nonres: 490.0 },
  { period: 'Q3 21', resi: 813.7, nonres: 497.3 },
  { period: 'Q4 21', resi: 858.6, nonres: 513.1 },
  { period: 'Q1 22', resi: 934.6, nonres: 541.4 },
  { period: 'Q2 22', resi: 966.7, nonres: 577.5 },
  { period: 'Q3 22', resi: 914.4, nonres: 614.3 },
  { period: 'Q4 22', resi: 873.0, nonres: 649.1 },
  { period: 'Q1 23', resi: 850.1, nonres: 705.9 },
  { period: 'Q2 23', resi: 859.5, nonres: 744.3 },
  { period: 'Q3 23', resi: 879.2, nonres: 760.5 },
  { period: 'Q4 23', resi: 889.8, nonres: 786.6 },
  { period: 'Q1 24', resi: 924.1, nonres: 791.7 },
  { period: 'Q2 24', resi: 938.3, nonres: 791.4 },
  { period: 'Q3 24', resi: 935.0, nonres: 800.5 },
  { period: 'Q4 24', resi: 930.1, nonres: 803.3 },
  { period: 'Q1 25', resi: 925.2, nonres: 801.5 },
  { period: 'Q2 25', resi: 915.9, nonres: 793.1 },
  { period: 'Q3 25', resi: 928.4, nonres: 778.2 },
  { period: 'Q4 25', resi: 922.7, nonres: 763.9 },
  { period: 'Q1 26', resi: 912.6, nonres: 747.0 },
  { period: 'Q2 26', resi: 875.8, nonres: 749.0 },
  { period: 'Q3 26*', resi: 859.0, nonres: 755.2 },
];

export const LONG_INPUT_PPI: { period: string; asphalt: number; shingles: number; lumber: number }[] = [
  { period: 'Q1 11', asphalt: 85.6, shingles: 87.6, lumber: 79.4 },
  { period: 'Q2 11', asphalt: 92.1, shingles: 91.3, lumber: 78.2 },
  { period: 'Q3 11', asphalt: 98.5, shingles: 97.1, lumber: 78.1 },
  { period: 'Q4 11', asphalt: 98.8, shingles: 93.7, lumber: 77.0 },
  { period: 'Q1 12', asphalt: 97.5, shingles: 89.8, lumber: 78.1 },
  { period: 'Q2 12', asphalt: 97.7, shingles: 92.5, lumber: 81.3 },
  { period: 'Q3 12', asphalt: 97.4, shingles: 94.6, lumber: 81.4 },
  { period: 'Q4 12', asphalt: 96.3, shingles: 94.0, lumber: 82.8 },
  { period: 'Q1 13', asphalt: 94.0, shingles: 92.5, lumber: 92.5 },
  { period: 'Q2 13', asphalt: 94.1, shingles: 96.1, lumber: 94.1 },
  { period: 'Q3 13', asphalt: 93.1, shingles: 97.0, lumber: 90.9 },
  { period: 'Q4 13', asphalt: 93.3, shingles: 94.1, lumber: 95.5 },
  { period: 'Q1 14', asphalt: 93.3, shingles: 92.3, lumber: 100.7 },
  { period: 'Q2 14', asphalt: 93.6, shingles: 93.8, lumber: 101.5 },
  { period: 'Q3 14', asphalt: 94.0, shingles: 92.0, lumber: 101.8 },
  { period: 'Q4 14', asphalt: 93.6, shingles: 94.6, lumber: 99.4 },
  { period: 'Q1 15', asphalt: 91.9, shingles: 93.5, lumber: 97.4 },
  { period: 'Q2 15', asphalt: 91.3, shingles: 92.0, lumber: 93.8 },
  { period: 'Q3 15', asphalt: 90.3, shingles: 92.4, lumber: 92.1 },
  { period: 'Q4 15', asphalt: 89.4, shingles: 92.0, lumber: 90.8 },
  { period: 'Q1 16', asphalt: 89.2, shingles: 91.1, lumber: 91.5 },
  { period: 'Q2 16', asphalt: 87.9, shingles: 91.8, lumber: 95.2 },
  { period: 'Q3 16', asphalt: 88.6, shingles: 92.3, lumber: 96.4 },
  { period: 'Q4 16', asphalt: 89.1, shingles: 91.6, lumber: 95.7 },
  { period: 'Q1 17', asphalt: 89.0, shingles: 90.3, lumber: 97.8 },
  { period: 'Q2 17', asphalt: 90.6, shingles: 91.0, lumber: 101.7 },
  { period: 'Q3 17', asphalt: 91.3, shingles: 91.7, lumber: 103.2 },
  { period: 'Q4 17', asphalt: 91.8, shingles: 92.3, lumber: 105.1 },
  { period: 'Q1 18', asphalt: 93.8, shingles: 91.4, lumber: 109.9 },
  { period: 'Q2 18', asphalt: 97.0, shingles: 95.7, lumber: 116.1 },
  { period: 'Q3 18', asphalt: 99.5, shingles: 98.2, lumber: 110.7 },
  { period: 'Q4 18', asphalt: 100.0, shingles: 101.3, lumber: 99.3 },
  { period: 'Q1 19', asphalt: 100.0, shingles: 100.0, lumber: 100.0 },
  { period: 'Q2 19', asphalt: 100.2, shingles: 100.4, lumber: 98.4 },
  { period: 'Q3 19', asphalt: 101.7, shingles: 100.3, lumber: 98.5 },
  { period: 'Q4 19', asphalt: 102.1, shingles: 101.0, lumber: 98.1 },
  { period: 'Q1 20', asphalt: 102.3, shingles: 101.8, lumber: 101.2 },
  { period: 'Q2 20', asphalt: 101.7, shingles: 100.9, lumber: 100.2 },
  { period: 'Q3 20', asphalt: 100.9, shingles: 103.1, lumber: 130.3 },
  { period: 'Q4 20', asphalt: 101.3, shingles: 102.9, lumber: 134.1 },
  { period: 'Q1 21', asphalt: 103.1, shingles: 104.8, lumber: 162.6 },
  { period: 'Q2 21', asphalt: 107.6, shingles: 110.4, lumber: 202.8 },
  { period: 'Q3 21', asphalt: 111.5, shingles: 115.7, lumber: 139.8 },
  { period: 'Q4 21', asphalt: 116.1, shingles: 119.8, lumber: 146.1 },
  { period: 'Q1 22', asphalt: 117.9, shingles: 125.9, lumber: 198.9 },
  { period: 'Q2 22', asphalt: 126.7, shingles: 131.1, lumber: 171.7 },
  { period: 'Q3 22', asphalt: 137.7, shingles: 133.6, lumber: 143.7 },
  { period: 'Q4 22', asphalt: 142.9, shingles: 135.2, lumber: 128.9 },
  { period: 'Q1 23', asphalt: 142.6, shingles: 131.9, lumber: 124.2 },
  { period: 'Q2 23', asphalt: 142.2, shingles: 135.9, lumber: 122.1 },
  { period: 'Q3 23', asphalt: 142.4, shingles: 138.4, lumber: 122.7 },
  { period: 'Q4 23', asphalt: 141.7, shingles: 139.2, lumber: 114.4 },
  { period: 'Q1 24', asphalt: 142.3, shingles: 139.5, lumber: 116.8 },
  { period: 'Q2 24', asphalt: 141.3, shingles: 139.3, lumber: 118.2 },
  { period: 'Q3 24', asphalt: 141.2, shingles: 139.7, lumber: 118.0 },
  { period: 'Q4 24', asphalt: 141.3, shingles: 141.8, lumber: 123.2 },
  { period: 'Q1 25', asphalt: 141.0, shingles: 139.9, lumber: 127.0 },
  { period: 'Q2 25', asphalt: 140.7, shingles: 141.8, lumber: 126.8 },
  { period: 'Q3 25', asphalt: 140.8, shingles: 143.5, lumber: 123.6 },
  { period: 'Q4 25', asphalt: 140.8, shingles: 142.8, lumber: 121.7 },
  { period: 'Q1 26', asphalt: 139.8, shingles: 139.8, lumber: 126.4 },
  { period: 'Q2 26', asphalt: 149.9, shingles: 143.2, lumber: 131.7 },
  { period: 'Q3 26*', asphalt: 161.9, shingles: 150.4, lumber: 135.5 },
];

export const LONG_BRANCH_COST: { period: string; diesel: number; freight: number }[] = [
  { period: 'Q1 11', diesel: 133.8, freight: 84.4 },
  { period: 'Q2 11', diesel: 152.1, freight: 86.6 },
  { period: 'Q3 11', diesel: 144.7, freight: 86.6 },
  { period: 'Q4 11', diesel: 145.5, freight: 87.3 },
  { period: 'Q1 12', diesel: 151.1, freight: 88.3 },
  { period: 'Q2 12', diesel: 145.8, freight: 89.1 },
  { period: 'Q3 12', diesel: 146.5, freight: 89.5 },
  { period: 'Q4 12', diesel: 150.6, freight: 90.2 },
  { period: 'Q1 13', diesel: 149.1, freight: 90.2 },
  { period: 'Q2 13', diesel: 141.3, freight: 90.2 },
  { period: 'Q3 13', diesel: 145.6, freight: 90.5 },
  { period: 'Q4 13', diesel: 142.7, freight: 90.8 },
  { period: 'Q1 14', diesel: 144.0, freight: 91.2 },
  { period: 'Q2 14', diesel: 143.3, freight: 92.6 },
  { period: 'Q3 14', diesel: 139.2, freight: 92.8 },
  { period: 'Q4 14', diesel: 119.3, freight: 92.1 },
  { period: 'Q1 15', diesel: 86.1, freight: 90.6 },
  { period: 'Q2 15', diesel: 88.8, freight: 90.8 },
  { period: 'Q3 15', diesel: 83.9, freight: 90.4 },
  { period: 'Q4 15', diesel: 71.6, freight: 90.1 },
  { period: 'Q1 16', diesel: 53.4, freight: 89.5 },
  { period: 'Q2 16', diesel: 64.3, freight: 89.4 },
  { period: 'Q3 16', diesel: 71.4, freight: 89.2 },
  { period: 'Q4 16', diesel: 72.2, freight: 90.0 },
  { period: 'Q1 17', diesel: 73.8, freight: 90.4 },
  { period: 'Q2 17', diesel: 77.1, freight: 90.8 },
  { period: 'Q3 17', diesel: 86.9, freight: 92.0 },
  { period: 'Q4 17', diesel: 100.3, freight: 93.6 },
  { period: 'Q1 18', diesel: 103.3, freight: 95.2 },
  { period: 'Q2 18', diesel: 113.0, freight: 96.8 },
  { period: 'Q3 18', diesel: 117.5, freight: 99.0 },
  { period: 'Q4 18', diesel: 116.8, freight: 100.4 },
  { period: 'Q1 19', diesel: 100.0, freight: 100.0 },
  { period: 'Q2 19', diesel: 102.8, freight: 100.1 },
  { period: 'Q3 19', diesel: 98.0, freight: 99.9 },
  { period: 'Q4 19', diesel: 102.4, freight: 100.3 },
  { period: 'Q1 20', diesel: 87.7, freight: 100.1 },
  { period: 'Q2 20', diesel: 56.1, freight: 97.2 },
  { period: 'Q3 20', diesel: 83.1, freight: 99.2 },
  { period: 'Q4 20', diesel: 93.1, freight: 101.7 },
  { period: 'Q1 21', diesel: 121.7, freight: 105.2 },
  { period: 'Q2 21', diesel: 139.5, freight: 110.0 },
  { period: 'Q3 21', diesel: 149.3, freight: 113.4 },
  { period: 'Q4 21', diesel: 165.0, freight: 119.4 },
  { period: 'Q1 22', diesel: 194.9, freight: 127.4 },
  { period: 'Q2 22', diesel: 270.5, freight: 136.5 },
  { period: 'Q3 22', diesel: 245.1, freight: 134.6 },
  { period: 'Q4 22', diesel: 244.4, freight: 132.2 },
  { period: 'Q1 23', diesel: 196.0, freight: 127.0 },
  { period: 'Q2 23', diesel: 166.0, freight: 120.8 },
  { period: 'Q3 23', diesel: 181.8, freight: 120.1 },
  { period: 'Q4 23', diesel: 173.6, freight: 120.9 },
  { period: 'Q1 24', diesel: 166.2, freight: 119.8 },
  { period: 'Q2 24', diesel: 155.1, freight: 120.4 },
  { period: 'Q3 24', diesel: 146.6, freight: 121.1 },
  { period: 'Q4 24', diesel: 140.4, freight: 119.8 },
  { period: 'Q1 25', diesel: 138.0, freight: 121.9 },
  { period: 'Q2 25', diesel: 131.0, freight: 121.0 },
  { period: 'Q3 25', diesel: 142.4, freight: 123.6 },
  { period: 'Q4 25', diesel: 137.2, freight: 124.2 },
  { period: 'Q1 26', diesel: 154.8, freight: 126.6 },
  { period: 'Q2 26', diesel: 235.4, freight: 139.0 },
  { period: 'Q3 26*', diesel: 229.9, freight: 140.2 },
];

export const LONG_CONSTRUCTION_LABOR: { period: string; empYoy: number; openYoy: number | null }[] = [
  { period: 'Q1 12', empYoy: 3.2, openYoy: 37.1 },
  { period: 'Q2 12', empYoy: 1.9, openYoy: 5.1 },
  { period: 'Q3 12', empYoy: 1.5, openYoy: 11.1 },
  { period: 'Q4 12', empYoy: 1.7, openYoy: 35.5 },
  { period: 'Q1 13', empYoy: 2.7, openYoy: 50.3 },
  { period: 'Q2 13', empYoy: 3.8, openYoy: 36.3 },
  { period: 'Q3 13', empYoy: 4.2, openYoy: 14.7 },
  { period: 'Q4 13', empYoy: 4.4, openYoy: 24.0 },
  { period: 'Q1 14', empYoy: 4.0, openYoy: 12.4 },
  { period: 'Q2 14', empYoy: 4.8, openYoy: 7.2 },
  { period: 'Q3 14', empYoy: 5.6, openYoy: 13.9 },
  { period: 'Q4 14', empYoy: 5.6, openYoy: 3.6 },
  { period: 'Q1 15', empYoy: 5.5, openYoy: 15.2 },
  { period: 'Q2 15', empYoy: 5.1, openYoy: 16.7 },
  { period: 'Q3 15', empYoy: 4.5, openYoy: 5.0 },
  { period: 'Q4 15', empYoy: 5.1, openYoy: -2.3 },
  { period: 'Q1 16', empYoy: 4.9, openYoy: 17.6 },
  { period: 'Q2 16', empYoy: 4.3, openYoy: 16.9 },
  { period: 'Q3 16', empYoy: 3.9, openYoy: 59.3 },
  { period: 'Q4 16', empYoy: 3.4, openYoy: 45.3 },
  { period: 'Q1 17', empYoy: 3.4, openYoy: -7.4 },
  { period: 'Q2 17', empYoy: 3.6, openYoy: 9.4 },
  { period: 'Q3 17', empYoy: 3.7, openYoy: -7.0 },
  { period: 'Q4 17', empYoy: 3.7, openYoy: 12.0 },
  { period: 'Q1 18', empYoy: 4.1, openYoy: 31.4 },
  { period: 'Q2 18', empYoy: 4.7, openYoy: 33.7 },
  { period: 'Q3 18', empYoy: 5.0, openYoy: 43.1 },
  { period: 'Q4 18', empYoy: 4.6, openYoy: 44.8 },
  { period: 'Q1 19', empYoy: 3.6, openYoy: 38.2 },
  { period: 'Q2 19', empYoy: 3.1, openYoy: 36.8 },
  { period: 'Q3 19', empYoy: 2.6, openYoy: 12.6 },
  { period: 'Q4 19', empYoy: 2.0, openYoy: -16.1 },
  { period: 'Q1 20', empYoy: 2.2, openYoy: -14.5 },
  { period: 'Q2 20', empYoy: -7.9, openYoy: -32.1 },
  { period: 'Q3 20', empYoy: -4.1, openYoy: -20.0 },
  { period: 'Q4 20', empYoy: -2.8, openYoy: -8.5 },
  { period: 'Q1 21', empYoy: -3.0, openYoy: 11.0 },
  { period: 'Q2 21', empYoy: 7.2, openYoy: 31.3 },
  { period: 'Q3 21', empYoy: 3.1, openYoy: 43.2 },
  { period: 'Q4 21', empYoy: 3.2, openYoy: 52.7 },
  { period: 'Q1 22', empYoy: 4.1, openYoy: 38.4 },
  { period: 'Q2 22', empYoy: 4.6, openYoy: 31.9 },
  { period: 'Q3 22', empYoy: 4.9, openYoy: 4.3 },
  { period: 'Q4 22', empYoy: 4.1, openYoy: -3.6 },
  { period: 'Q1 23', empYoy: 3.8, openYoy: -22.5 },
  { period: 'Q2 23', empYoy: 3.1, openYoy: -5.6 },
  { period: 'Q3 23', empYoy: 2.9, openYoy: 2.8 },
  { period: 'Q4 23', empYoy: 2.9, openYoy: 14.8 },
  { period: 'Q1 24', empYoy: 2.6, openYoy: 18.2 },
  { period: 'Q2 24', empYoy: 2.6, openYoy: -14.7 },
  { period: 'Q3 24', empYoy: 2.4, openYoy: -30.8 },
  { period: 'Q4 24', empYoy: 2.2, openYoy: -52.2 },
  { period: 'Q1 25', empYoy: 1.6, openYoy: -33.4 },
  { period: 'Q2 25', empYoy: 1.1, openYoy: -35.1 },
  { period: 'Q3 25', empYoy: 0.2, openYoy: -13.5 },
  { period: 'Q4 25', empYoy: -0.0, openYoy: 20.3 },
  { period: 'Q1 26', empYoy: 0.5, openYoy: -13.1 },
  { period: 'Q2 26', empYoy: 0.6, openYoy: 30.9 },
  { period: 'Q3 26*', empYoy: 1.2, openYoy: 35.1 },
];

/** Annual closed existing-home sales, millions. NAR, as compiled by YCharts. 2018–2025 matches the overview file. */

export const LONG_EXISTING_HOME_SALES: { year: string; salesM: number }[] = [
  { year: '2011', salesM: 4.26 },
  { year: '2012', salesM: 4.66 },
  { year: '2013', salesM: 5.09 },
  { year: '2014', salesM: 4.94 },
  { year: '2015', salesM: 5.25 },
  { year: '2016', salesM: 5.45 },
  { year: '2017', salesM: 5.51 },
  { year: '2018', salesM: 5.34 },
  { year: '2019', salesM: 5.34 },
  { year: '2020', salesM: 5.64 },
  { year: '2021', salesM: 6.12 },
  { year: '2022', salesM: 5.03 },
  { year: '2023', salesM: 4.09 },
  { year: '2024', salesM: 4.06 },
  { year: '2025', salesM: 4.06 },
];
